import { RootState } from "../../../redux-store";

export const selectStopDocuments = (stopId: string) => (state: RootState) =>
  state.data.stopDocuments.byStopId[stopId] || [];
